import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/contexts/useAuth";
import { apiGet, getApiErrorMessage } from "@/api";
import { tokenQuery } from "./query-options";

export interface CrmConnection {
  provider: string;
  connectedAt: string;
}

export function crmStatusQueryOptions(token: string | null) {
  return tokenQuery(["crm-status"], token, async (t) => {
    const res = await apiGet<{ connections?: CrmConnection[] }>("/crm/status", t);
    if (!res.ok) throw new Error(getApiErrorMessage(res, "CRM-Status konnte nicht geladen werden"));
    return res.data.connections ?? [];
  });
}

export function useCrmStatus() {
  const { state } = useAuth();
  const token = state.status === "authenticated" ? state.token : null;
  return useQuery(crmStatusQueryOptions(token));
}
